import ProcedimentoService from '@/src/services/procedimentos'

const procedimentoMixin = {
  data() {
    return {
      procedimentosFields: [
        {
          key: 'descricao',
          label: 'Descrição',
          class: 'size-col-20',
          field: 'descricao',
        },
        {
          key: 'grupo.grupo',
          label: 'Grupo',
          class: 'size-col-20',
          field: 'grupo.grupo',
        },
        { key: 'actions', label: '', class: 'size-col-10' },
      ],
    }
  },
  methods: {
    async registerProcedimento(procedimento) {
      await ProcedimentoService.create(procedimento)
    },
    loadProcedimentos(grupo = null) {
      return ProcedimentoService.list(grupo).then((response) => response.data)
    },
    async editProcedimento(id, procedimento) {
      await ProcedimentoService.update(id, procedimento)
    },
    async deleteProcedimento(id) {
      await ProcedimentoService.remove(id)
    },
    async findOneProcedure(id) {
      const data = await ProcedimentoService.findOne(id)

      return data
    },
    async findOneByDescription(description) {
      const data = await ProcedimentoService.findOneByDescription(description)

      return data
    }
  },
}

export default procedimentoMixin